export default __webpack_public_path__ + "static/media/faqbaseimage.dfa618c9.svg";